// utils/rowSelectors.js
export const splitSelectedRows = (selectedIds, rows) => {
    const locked = [];
    const unlocked = [];

    selectedIds.forEach(id => {
        const row = rows.find(r => r.id === id);
        (row && row.isLocked ? locked : unlocked).push(id);
    });

    return {
        locked,
        unlocked,
        allLocked: locked.length === selectedIds.length,
        allUnlocked: unlocked.length === selectedIds.length,
        anyLocked: locked.length > 0,
        anyUnlocked: unlocked.length > 0,
    };
};